import React, {createRef} from 'react';
import AttachmentsListByType from "../attachments-list/list-by-type";
// @ts-ignore
import DropzoneNew from "../dropzone/dropzone";
// @ts-ignore
import GoogleDriveAttach from "../../../../app/common/attachments/attachment/google-drive-attach";
import ErrorBoundary from "../../../error-boundary";
import Attachment from "../../../model2/attachment/attachment";
// @ts-ignore
import {Deferred} from "simply-deferred";
import AttachmentsCollection from "../../../model2/attachment/attachments";
import {AttachFileMode} from "../const";
import {AttachmentSystemType} from "../../../model2/attachment/@types";

const debug = false
// const debug = "AttachmentsManager"

type Props = {
    attachmentsCollection   : AttachmentsCollection
    mode                    : AttachFileMode
    dropzoneDOMElementId?   : ID
    dzId?                   : ID

    onChange?               : callback   // callback to save changes
    saveNewUpload?          : callback   // callback when news file have been uploaded
    saveRemoveFile?         : callback   // callback when news file have been removed
    onNewUploadStarted?     : callback   // callback when new upload starts
    systemType?             : AttachmentSystemType

    onAddToMessage?         : callback   // if passed we can add attachments to message RTF
    className?              : string
    attachmentsData?        : any        // ?????
    autoAddToMessage?       : boolean
    onlySingleFile?         : boolean
}

type State = {
    dropzoneEnabled: boolean
    reRender       : boolean
}

export default class AttachmentsManager extends React.Component<Props, State> {

    static defaultProps = {
        dzId: "attachments-manager-edit",
        // systemType: AttachmentSystemType.DEFAULT
    }

    public dropzone      : React.RefObject<any>
    public refGoogleDrive: React.RefObject<any>

    constructor(props: Props) {

        super(props);

        this.state = {
            dropzoneEnabled : true,
            reRender        : false
        }

        this.dropzone       = createRef();
        this.refGoogleDrive = createRef()

        debug && console.log(debug, "Constructor", "mode=", this.props.mode, "attachments=", this.props.attachmentsCollection)
    }

    componentDidUpdate() {
        // console.log("todo")
        if (this.refGoogleDrive.current) this.refGoogleDrive.current.updateAttachments();
    }

    componentWillUnmount() {

        // this.attachmentsCollection = null
        //
    }

    reRender() {
        const reRenderDone = new Deferred();

        this.setState({
            reRender: true
        }, ()=>{reRenderDone.resolve();})

        return reRenderDone
    }

    // patch
    // when edit chat message = new dropzone = problem with current so we manually kill it
    toggleDropzone = (value: any) => {
        const newValue = !_.isNil(value) ? value : !this.state.dropzoneEnabled;
        this.setState({
            dropzoneEnabled: newValue
        })
    }


    // TEXT EDITOR

    onMessageRTFChanged = (messageRTF: any) => {
        const hasChanged = this.props.attachmentsCollection.applyMessageRTF(messageRTF)
        if (hasChanged) this.reRender()
    }

    // called by Text Editor when new file pasted into message
    pasteImage = (file: any) => {
        debug && console.log(debug, ".pasteImage()", file.name)
        file._pastedFromTextEditor = true
        this.dropzone.current.pasteImage(file)
    }

    // ACTIONS

    resetAttachments = ()=>{
        if (this.dropzone.current) this.dropzone.current.resetFiles();
    }

    selectAttachment = (value: any) => {
        switch (value) {
            case 'google-drive':
                if (this.refGoogleDrive.current) this.refGoogleDrive.current.onClick();
                break;

            case 'local':
            default:
                if (this.dropzone.current) this.dropzone.current.click();
                break;
        }
    }

    // UPLOAD

    onFileUploadStart = (attachment: Attachment) => {
        this.props.attachmentsCollection.add(attachment)

        this.reRender().
            then(()=>{
                if (this.props.onNewUploadStarted) this.props.onNewUploadStarted(attachment)
            });
    }

    onFileUploadDone = async (attachment: Attachment) => {
        // console.green("upload done")

        // auto add pasted images into editor or all attachments if autoAddToMessage is enabled
        if (this.props.onAddToMessage &&
            (_.get(attachment,'dropzoneFile._pastedFromTextEditor') || this.props.autoAddToMessage)) {
            this.props.onAddToMessage(attachment)
        }

        attachment.dropzoneUploadDone = true
        attachment.systemType         = this.props.systemType || AttachmentSystemType.DEFAULT;

        // autosave new added file ?
        if (this.props.saveNewUpload) {
            this.props.saveNewUpload(attachment, ()=>{
                // console.log("FILE HAVE BEEN SAVED")
                attachment.dropzoneFile       = null;
                attachment.dropzoneUploadDone = null;
                attachment.isSaved            = true;

                this.reRender()
            })
        }

        // generic onChange
        if (this.props.onChange) {
            this.props.onChange(this.props.attachmentsCollection)
        }
    }

    //
    onRemove = (attachment: Attachment) => {

        // console.red("REMOVE attachment")

        // remove from collection (!)
        this.props.attachmentsCollection.remove(attachment)

        if (attachment.isNewUpload) {
            this.dropzone.current.removeFile(attachment.fileId);
        }

        if (attachment.isSaved) {
            if (this.props.saveRemoveFile) {
                this.props.saveRemoveFile(attachment, ()=>{
                    // console.log("SAVE REMOVE DONE")
                })
            }
        }

        // generic onChange
        if (this.props.onChange) {
            this.props.onChange(this.props.attachmentsCollection)
        }

        if(attachment.systemType === AttachmentSystemType.CUSTOM){
            attachment.delete()
        }

        this.reRender()
    }

    onChangeGoogleDriveAttachments = (googleDriveFiles: any) => {

        if (_.isEmpty(googleDriveFiles)) return

        // convert to attachmetns
        const newAttachments = _.map(googleDriveFiles, googleDriveFile=>{

            const newAttachment = Attachment.initFromGoogleDrive(googleDriveFile)

            this.props.attachmentsCollection.add(newAttachment)

            // autosave new added file ?
            if (this.props.saveNewUpload) {
                this.props.saveNewUpload(newAttachment, ()=>{
                    newAttachment.isSaved = true;
                    this.reRender()
                })
            }

            return newAttachment
        })

        // generic onChange
        if (this.props.onChange) {
            this.props.onChange(this.props.attachmentsCollection)
        }

        // auto add newAttachments into editor
        if (this.props.onAddToMessage && this.props.autoAddToMessage) {
            this.props.onAddToMessage(newAttachments)
        }

        // always render here
        this.reRender()
    }

    render() {
        debug && console.log(debug, "render()", this.state.dropzoneEnabled, this.props.dropzoneDOMElementId, this.props.attachmentsCollection)

        const classes = Classes('gd-attachments-manager',{
            'is-empty'               : this.props.attachmentsCollection.isEmpty,
            'no-visible-attachments' : !this.props.attachmentsCollection.attachmentsNotInMessagesTotal,
            'w-100-percent'          : this.props.mode === AttachFileMode.VIEW_SMALL || this.props.mode === AttachFileMode.VIEW_AND_EDIT_SMALL,
        })

        // Eto dlya shared view forms. Tam net "ui-page".
        // "body" is the last resort (ticket-view has neither container):
        // dropzone throws if the selector matches no element at all.
        const hiddenInputContainer = _.find(["#ui-page", "#ui-layout-container"], (selector: string) => {
            return !!document.querySelector(selector)
        }) || "body"

        return (
            <div className={classes}>

                <ErrorBoundary>
                    <AttachmentsListByType attachments    = {this.props.attachmentsCollection}
                                           mode           = {this.props.mode}
                                           onRemove       = {this.onRemove}
                                           className      = {this.props.className}
                                           onAddToMessage = {this.props.onAddToMessage}/>

                    {this.props.mode !== AttachFileMode.VIEW && this.state.dropzoneEnabled &&
                        <DropzoneNew ref                    = {this.dropzone}
                                     attachmentsManager     = {this}
                                     mode                   = {this.props.mode}
                                     onlySingleFile         = {this.props.onlySingleFile}
                                     name                   = "files"
                                     hiddenInputContainer   = {hiddenInputContainer}
                                     dzId                   = {this.props.dzId}
                                     djsContainer           = {"#{0}".f(this.props.dropzoneDOMElementId)}/>}

                    {this.props.mode !== AttachFileMode.VIEW &&
                    <GoogleDriveAttach ref            = {this.refGoogleDrive}
                                       attachments    = {this.props.attachmentsData}
                                       organizationId = {gd.companyId}
                                       onChange       = {this.onChangeGoogleDriveAttachments}
                    />}
                </ErrorBoundary>
            </div>
        );
    }
}
